import PropTypes from 'prop-types';

import masterCard from '../../assets/images/paymentMethod_masterCard.svg';
import mirImg from '../../assets/images/paymentMethod_mir.svg';
import visaImg from '../../assets/images/paymentMethod_visa.svg';
import radioHover from '../../assets/images/Radio.svg';
import radio from '../../assets/images/RadioDef.svg';
import styles from './styles/styles.module.css';

function BankCardItemPayment({ card, isSelected, setCard }) {
  console.log(card);
  let src = mirImg;
  switch (card.type) {
    case 'MIR':
      src = mirImg;
      break;
    case 'Visa':
      src = visaImg;
      break;
    case 'Mastercard':
      src = masterCard;
      break;
    default:
      src = mirImg;
      break;
  }
  return (
    <button className={styles.cardWrapper} onClick={() => setCard(card)}>
      <div className={styles.cardInfo}>
        <img src={isSelected ? radioHover : radio} width={24} height={24} />
        {src ? (
          <img src={src} alt="" className={styles.bankCardLogo} />
        ) : (
          <span className={styles.bankCardNoImgContainer} />
        )}
        <span>****{card.last_nums}</span>
      </div>
      {card.default && <span className={`${styles.bankCardBasicText}`}>Основная</span>}
    </button>
  );
}

BankCardItemPayment.propTypes = {
  card: PropTypes.shape({
    type: PropTypes.string.isRequired,
    last_nums: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    default: PropTypes.bool,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  setCard: PropTypes.func.isRequired,
};

export default BankCardItemPayment;
